export const DEFAULT_HOT_SPOT_CONFIG = {
  radius: 0.12,
  segments: 64,
  positionZ: 0.1,
  background: 'white',
  textPositionZ: 0.001,
  fontSize: 0.1,
  fontColor: 'black'
}
